import { Component, Input, OnDestroy, ChangeDetectorRef, ViewChild, ElementRef, AfterViewInit, Inject } from '@angular/core';
import { CdkDragMove, CdkDragRelease } from '@angular/cdk/drag-drop';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-audio-modal',
  templateUrl: './audio-modal.component.html',
  styleUrls: ['./audio-modal.component.scss'],
})
export class AudioModalComponent implements OnDestroy, AfterViewInit {

  @Input() audioUrl: string | null = null;
  @Input() campaignName: string | null = 'Selected Campaign';
  @Input() kampaniaName: string | null = 'Nazwa kampanii';

  @ViewChild('audioElement') audioElementRef!: ElementRef<HTMLAudioElement>;

  initialized = false;
  
  isPaused = true;
  currentTime = 0;
  duration = 0;
  progress = 0;
  volume = 1;
  playbackRate = 1;
  isMinimized = false; 
  position = { x: 0, y: 0 };

  constructor(
    public dialogRef: MatDialogRef<AudioModalComponent>,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: { 
      audioUrl: string | null; 
      campaignName: string; 
      kampaniaName: string; 
    }
  ) {
    // Initialize the passed data
    this.audioUrl = data.audioUrl;
    this.campaignName = data.campaignName;
    console.log('data ',data)
    this.kampaniaName = data.kampaniaName;
  }

  ngAfterViewInit(): void {
    if (this.audioElementRef && this.audioElementRef.nativeElement) {
      const audioElement = this.audioElementRef.nativeElement;
  
      // Set initial values for the audio element
      audioElement.src = this.audioUrl || ''; 
      audioElement.volume = this.volume;
      audioElement.playbackRate = this.playbackRate;
  
      // Handle play and pause events
      audioElement.onplay = () => {
        this.isPaused = false; // Audio is playing, so the button should show "pause"
        this.cdr.detectChanges();
      };
  
      audioElement.onpause = () => {
        this.isPaused = true; // Audio is paused, so the button should show "play"
        this.cdr.detectChanges();
      };
  
      // Handle metadata loaded event (fetches duration)
      audioElement.onloadedmetadata = () => {
        this.duration = audioElement.duration;
        this.cdr.detectChanges();
      };
  
      // Handle time update event to update progress
      audioElement.ontimeupdate = () => {
        if (this.duration && this.duration > 0) {
          this.currentTime = audioElement.currentTime;
          this.progress = (this.currentTime / this.duration) * 100;
        } else {
          this.progress = 0;
        }
        this.cdr.detectChanges(); // Force change detection
      };
  
      // Handle audio end event to reset the player
      audioElement.onended = () => {
        this.resetAudio();
        this.cdr.detectChanges();
      };
  
      // Handle audio error event
      audioElement.onerror = (error) => console.error('Audio error:', error);
  
      // Auto-play the audio once the component is initialized
      audioElement.play().catch((error) => {
        console.error('Error playing audio:', error);
      });
    }
  }
  

  
  

  handleLoadedMetadata(): void {
    const audioElement = this.audioElementRef.nativeElement;
    this.duration = audioElement.duration;
    this.cdr.detectChanges();
  }

  handleTimeUpdate(): void {
    const audioElement = this.audioElementRef.nativeElement;
    this.currentTime = audioElement.currentTime;
    this.progress = (this.currentTime / this.duration) * 100;
    this.cdr.detectChanges();
  }
  

  handleAudioEnded(): void {
    this.resetAudio();
    this.cdr.detectChanges();
  }

  // Method to toggle play/pause button manually
  togglePlayPause(): void {
    const audioElement = this.audioElementRef.nativeElement;
    if (audioElement) {
      if (this.isPaused) {
        // Play the audio if it is paused
        audioElement.play().catch((error) => {
          console.error('Error playing audio:', error);
        });
      } else {
        // Pause the audio if it is playing
        audioElement.pause();
      }
      this.cdr.detectChanges();
    }
  }

  toggleMute(): void {
    const audioElement = this.audioElementRef.nativeElement;
    audioElement.muted = !audioElement.muted;
    this.volume = audioElement.muted ? 0 : 1;
    this.cdr.detectChanges();
  }

  changeVolume(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.volume = parseFloat(inputElement.value);
    this.audioElementRef.nativeElement.volume = this.volume;
    this.cdr.detectChanges();
  }

  setAudioProgress(event: MouseEvent): void {
    const audioElement = this.audioElementRef.nativeElement;
    const progressBar = event.currentTarget as HTMLElement;
    const rect = progressBar.getBoundingClientRect();
    const offsetX = event.clientX - rect.left;
    const width = rect.width;
    
    // Calculate percentage of click position within the progress bar
    const percentage = offsetX / width;
    
    // Ensure duration is defined and positive
    if (this.duration && this.duration > 0) {
      const newTime = percentage * this.duration;
      audioElement.currentTime = newTime;
      this.progress = percentage * 100;
    }
    
    this.cdr.detectChanges();
  }
  

  resetAudio(): void {
    const audioElement = this.audioElementRef.nativeElement;
    if (audioElement) {
      this.stop(audioElement);
    }
  }

  stop(audioElement: HTMLAudioElement): void {
    if (audioElement) {
      audioElement.pause();
      audioElement.currentTime = 0;
      this.isPaused = true;
      this.progress = 0;
      this.cdr.detectChanges();
    }
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60).toString().padStart(2, '0');
    const secs = Math.floor(seconds % 60).toString().padStart(2, '0');
    return `${minutes}:${secs}`;
  }

  changePlaybackRate(rate: number): void {
    this.playbackRate = rate;
    this.audioElementRef.nativeElement.playbackRate = rate;
    this.cdr.detectChanges();
  }

  minimizeModal(): void {
    this.isMinimized = true;
    this.cdr.detectChanges();
  }

  maximizeModal(): void {
    this.isMinimized = false;
    this.cdr.detectChanges();
  }

  closeModal(): void {
    this.resetAudio(); // Stop and reset the audio
    this.dialogRef.close(); // Close the dialog, which will trigger the afterClosed observable
  }
  

  ngOnDestroy(): void {
    this.resetAudio();
  }

  onDragMoved(event: CdkDragMove<any>): void {
    this.position = {
      x: event.pointerPosition.x,
      y: event.pointerPosition.y,
    };
    this.cdr.detectChanges();
  }
  
  onDragReleased(event: CdkDragRelease): void {
    console.log('Drag released:', event);
    this.cdr.detectChanges();
  }
}
